import { useQuery } from '@tanstack/react-query'
import { getProcurementPurchaseOrderDashboardCounts } from 'api'
import {
  PartialyRecieved,
  PoCreated,
  Recieved,
  SentToSupplier,
  TotalValue,
} from 'assets/icons/ProcurementDashboard'
import { Flex } from 'styling/GlobalStyles'
import { ColorVariant, Heading1, SmallText, TinyText } from 'styling/TypographyV2'
import { tokens } from 'styling/tokens'
import { CountContainer, IconContainer, ItemContainer } from './DashboardCount.styles'

type TItem = {
  icon: React.ReactNode
  title: string
  description: string
  count: number
  color: string
}

export const OrderDashboardCount = () => {
  const { data } = useQuery({
    queryKey: ['procurement-purchase-order-dashboard-counts'],
    queryFn: () => getProcurementPurchaseOrderDashboardCounts(),
  })
  const items: TItem[] = [
    {
      icon: <PoCreated />,
      title: 'PO created',
      description: 'Purchase orders created',
      count: data?.createdCount || 0,
      color: tokens.status.warning.fg,
    },
    {
      icon: <SentToSupplier />,
      title: 'Sent to supplier',
      description: 'Purchase orders sent to supplier',
      count: data?.sentToSupplierCount || 0,
      color: tokens.status.info.fg,
    },
    {
      icon: <PartialyRecieved />,
      title: 'Partially received',
      description: 'Purchase orders partially received',
      count: data?.partiallyReceivedCount || 0,
      color: tokens.accent.base,
    },
    {
      icon: <Recieved />,
      title: 'Received',
      description: 'Purchase orders received',
      count: data?.receivedCount || 0,
      color: tokens.status.success.fg,
    },
    {
      icon: <TotalValue />,
      title: 'Total value',
      description: 'Purchase orders total value',
      count: data?.totalValue || 0,
      color: tokens.status.neutral.fg,
    },
  ]

  return (
    <CountContainer>
      {items.map((item) => (
        <Item key={item.title} item={item} />
      ))}
    </CountContainer>
  )
}

const Item = ({ item }: { item: TItem }) => {
  return (
    <ItemContainer hexColor={item.color}>
      <IconContainer hexColor={item.color}>{item.icon}</IconContainer>
      <Flex column gap='4px'>
        <Heading1>{item.count}</Heading1>
        <SmallText colorVariant={ColorVariant.SECONDARY} uppercase bold>
          {item.title}
        </SmallText>
        <TinyText colorVariant={ColorVariant.FADED}>{item.description}</TinyText>
      </Flex>
    </ItemContainer>
  )
}
